<template>
  <div>
    <v-alert :color="color" class="rounded-lg ma-0">
      <v-icon size="28" :color="iconColor">{{ icon }}</v-icon>

      <div class="ms-4 text-start align-center">
        <div class="caption font-weight-bold textLight--text align-center">
          <span class="text-ellipse-1">{{ text }}</span>

          <span
            v-if="text2"
            class="caption font-weight-regular textLight--text text-ellipse-1"
          >
            {{ text2 }}
          </span>
        </div>
      </div>
    </v-alert>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      required: false,
    },
    text: {
      type: String,
      required: true,
    },
    text2: {
      type: String,
    },
    color: {
      type: String,
      required: true,
    },
  },
};
</script>
<style scoped>
>>> .v-alert__content {
  display: flex;
}
</style>
